import '../index.css';
var styles = {
  "emptyState": "bp_empty_state_module_emptyState--100a9",
  "illustration": "bp_empty_state_module_illustration--100a9",
  "body": "bp_empty_state_module_body--100a9",
  "heading": "bp_empty_state_module_heading--100a9",
  "button": "bp_empty_state_module_button--100a9",
  "small": "bp_empty_state_module_small--100a9"
};
export { styles as default };